/* eslint-disable */
// prettier-ignore

export default ((s: string) => {
  s = s.replace(/\<embed alt="([\w\s]+)" embedtype="image" format="\w+" id="(\d+)"*.>/g, '<img src=\'/is/$2/original/\' alt=\'$1\' class=\'postImage\'/>');

  // fix embedded videos that arrives in <embed embedtype="media url="https://youtube.com/id"/>"
  s = s.replace(/\<embed embedtype="media" url=".*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?"]*).*"*.>/g, '<div class=\'iframeEmbed\'><iframe width=\'500\' height=\'300\' src=\'https://www.youtube.com/embed/$2\' frameBorder=\'0\'></iframe></div>');

  // Fix embedded documents that arrives in <a id="19" linktype="document">document_name.pdf</a>
  s = s.replace(/\<a id="(\d+)" linktype="([\w\s]+)">([\.\w\s]+)\<\/a>/g, '<a href=\'/documents/$1/$3\'>$3</a>');

  return s;
});
